import '.c4{position:relative;}.ssr-plugin'
import '.t{width:100%;}.ssr-plugin'
import '.g8{min-height:200px;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.c{justify-content:center;}.ssr-plugin'
import '.co{align-items:flex-start;}.ssr-plugin'
import '.v{padding:2rem;}.ssr-plugin'
import '.d2{background:var(--shades-white);}.ssr-plugin'
import '.a6{overflow:hidden;}.ssr-plugin'
import '.a2{position:absolute;}.ssr-plugin'
import '.io{top:50%;}.ssr-plugin'
import '.ip{right:1rem;}.ssr-plugin'
import '.iq{transform:translateY(-50%);}.ssr-plugin'
import '.ir{width:120px;}.ssr-plugin'
import '.is{height:120px;}.ssr-plugin'
import '.it{z-index:0;}.ssr-plugin'
import '.d{align-items:center;}.ssr-plugin'
import '.ht{z-index:1;}.ssr-plugin'
import '.bb{gap:0.5rem;}.ssr-plugin'
import '.iu{max-width:calc(100% - 140px);}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { Text } from '@app/components/core/typography/Text'
import { Image } from '@app/components/core/image/Image'

export interface StatisticProps {
  number: string
  subtitle: string
  illustration?: string
  style?: Style
}

export const Statistic = ({
  number,
  subtitle,
  illustration,
  style,
}: StatisticProps) => {
  return (
    <styled.div className="c4 t g8 a b c co v d2 a6"
      data-testid="statistic"
      style={{
        ...style,
      }}
    >
      {/* Background Illustration - Right Aligned */}
      {illustration && (
        <div className="a2 io ip iq ir is it a d c"
        >
          <Image
            src={illustration}
            alt={`${subtitle} illustration`}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
            }}
          />
        </div>
      )}

      {/* Content - Left Aligned with higher z-index */}
      <div className="c4 ht a b co bb iu"
      >
        {/* Bold Number */}
        <Title.H1
          style={{
            fontSize: '4rem',
            fontWeight: '700',
            lineHeight: '100%',
            margin: 0,
            color: 'var(--primary-blue)',
            fontFamily: 'FunnelDisplay',
          }}
        >
          {number}
        </Title.H1>

        {/* Subtitle */}
        <Text.Medium
          style={{
            color: 'var(--primary-blue)',
            opacity: 0.8,
            margin: 0,
            lineHeight: '140%',
            fontWeight: '400',
          }}
        >
          {subtitle}
        </Text.Medium>
      </div>
    </styled.div>
  )
}
